import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Home.css";

import D1Video from "../assets/D1.mp4";

import About from "./About";
import Services from "./Services";
import Contact from "./Contact";

const Home = () => {
  const navigate = useNavigate();

  // Google Drive PDF
  const pdfLink =
    "https://drive.google.com/file/d/13kv_z-R_VWbtGsF_vY6La6ZnZVovesML/view?usp=sharing";

  return (
    <>
      {/* Home */}
      <section className="page home-page" id="home">
        <video
          className="background-video"
          src={D1Video}
          autoPlay
          loop
          muted
          playsInline
        >
          Your browser does not support the video tag.
        </video>

        <div className="content-overlay">
          <h1>Reliable Partners in International Trade</h1>

          <p>Bridging Trade Between Ethiopia and China</p>

          <div className="button-group">

            {/* PDF */}
            <button
              className="start-trading-btn"
              onClick={() => window.open(pdfLink, "_blank")}
            >
              View Service Packages
            </button>

            {/* Go to Order Page */}
            <button
              className="discover-btn"
              onClick={() => navigate("/order")}
            >
              Start Your Order
            </button>

          </div>
        </div>
      </section>

      {/* About */}
      <section id="about">
        <About />
      </section>

      {/* Services */}
      <section id="services">
        <Services />
      </section>

      {/* Contact */}
      <section id="contact">
        <Contact />
      </section>
    </>
  );
};

export default Home;